import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import TableSkeleton from "../TableSkeleton";

const GeneralStatsSkeleton = () => {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
			<Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
				<Skeleton variant="rectangular" width={255.7} height={36.7} />
				<Skeleton variant="rectangular" width={256.25} height={35.8} />
				<Skeleton variant="rectangular" width={272} height={36.7} />
				<Skeleton variant="rectangular" width={70} height={35.8} />
				<Skeleton variant="rectangular" width={157} height={35.8} />
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: "20px",
				}}
			>
				<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
				</Box>
				<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
					<Skeleton
						variant="rectangular"
						height={132}
						sx={{
							flex: "0 1 30.12%",
							minWidth: "unset",
							"@media (min-width: 1620px)": {
								flex: "0 1 15.12%",
							},
						}}
					/>
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: "16px",
				}}
			>
				<Box sx={{ display: "flex" }}>
					<Box sx={{ flex: "1", mt: "16px" }}>
						<Skeleton variant="rectangular" width={600} height={34} />
					</Box>
				</Box>

				<TableSkeleton />
			</Box>
		</Box>
	);
};

export default GeneralStatsSkeleton;
